import React from 'react';
import { Box, Chip, Typography } from '@mui/material';

// Shared fulfillment-center filter row. Callers pass fcNames sorted by
// shipment volume (highest first) so the ordering is consistent across
// sections; extra captions render after the chips.
export default function FcFilterChips({
  fcNames,
  selected,
  onSelect,
  children,
}: {
  fcNames: string[];
  selected: string;
  onSelect: (fc: string) => void;
  children?: React.ReactNode;
}) {
  return (
    <Box
      sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}
    >
      <Typography variant="caption" sx={{ color: '#64748B', fontWeight: 700 }}>
        FULFILLMENT CENTER
      </Typography>
      {['All', ...fcNames].map(fc => (
        <Chip
          key={fc}
          size="small"
          label={fc}
          onClick={() => onSelect(fc)}
          variant={selected === fc ? 'filled' : 'outlined'}
          sx={
            selected === fc
              ? { backgroundColor: '#4F46E5', color: '#fff', fontWeight: 600 }
              : { color: '#475569' }
          }
        />
      ))}
      {children}
    </Box>
  );
}
